import { render, staticRenderFns } from "./DepositInputModal.vue?vue&type=template&id=1ebf4fda&"
import script from "./DepositInputModal.vue?vue&type=script&lang=ts&"
export * from "./DepositInputModal.vue?vue&type=script&lang=ts&"
import style0 from "./DepositInputModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports